// src/components/ComplianceProgressCircle.js
import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

const ComplianceProgressCircle = ({ value, label, isLoading = false, size = 42 }) => {
    let color = 'success';
    if (value < 50) color = 'error';
    else if (value < 80) color = 'warning';

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: 60 }}>
            <Box sx={{ position: 'relative', display: 'inline-flex', width: size, height: size }}>
                {isLoading ? (
                    <CircularProgress size={size} />
                ) : (
                    <>
                        <CircularProgress
                            variant="determinate"
                            value={100}
                            sx={{ color: (theme) => theme.palette.grey[200], position: 'absolute' }}
                            size={size}
                            thickness={4.5}
                        />
                        <CircularProgress
                            variant="determinate"
                            value={value}
                            color={color}
                            size={size}
                            thickness={4.5}
                        />
                        <Box
                            sx={{
                                top: 0, left: 0, bottom: 0, right: 0,
                                position: 'absolute',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <Typography 
                                variant="caption" 
                                component="div" 
                                color="text.secondary" 
                                sx={{ fontWeight: 'bold', fontSize: '0.75rem' }}
                            >
                                {`${Math.round(value || 0)}%`}
                            </Typography>
                        </Box>
                    </>
                )}
            </Box>
            <Typography variant="caption" component="div" color="text.secondary" sx={{ mt: 0.5, fontWeight: 500 }}>
                {label}
            </Typography>
        </Box>
    );
};

export default ComplianceProgressCircle;